// Vehicles module - handles all vehicle-related functionality
import { setupInfiniteScroll, setupGenericSearch } from "../../utils/common.js";
import { getMasksValidator } from "../shared/masks-validator.js";

import { initVehicleFilters } from "./filter.js";

let paginationInstance = null;

// Vehicle listing with infinite scroll
if ($("body").hasClass("vehicle-index")) {
    initVehicleFilters();
    paginationInstance = setupInfiniteScroll(
        ".tbodyVehicles",
        "/veiculos",
        "#currentPage"
    );
}

// Initialize masks for vehicle forms
$(document).ready(function () {
    const masksValidator = getMasksValidator();

    // Apply masks specifically for vehicle forms
    if ($(".plate-mask").length > 0) {
        masksValidator.setupPlateMasks();
    }
});

// Vehicle search functionality
setupGenericSearch(
    "#searchVehicle",
    "/veiculos/search",
    ".table-vehicle",
    ".tbodyVehicles",
    function () {
        return {
            tipo_veiculo: $("#filterTipoVeiculo").val(),
            placa: $("#placaFilter").val(),
            marca: $("#marcaFilter").val(),
            modelo: $("#modeloFilter").val(),
            cor: $("#corFilter").val(),
            order_by: $("#orderBySelect").val(),
        };
    }
);

// Update pagination when search completes
$(document).on("search:success", function (e, response, data) {
    if (paginationInstance) {
        paginationInstance.page = 2;

        const hasFilters =
            data.value ||
            data.tipo_veiculo ||
            data.placa ||
            data.marca ||
            data.modelo ||
            data.cor;

        if (hasFilters) {
            paginationInstance.config.loadUrl = "/veiculos/search";
            paginationInstance.config.extraParams = data;
        } else {
            paginationInstance.config.loadUrl = "/veiculos";
            paginationInstance.config.extraParams = {};
        }

        paginationInstance.loading = false;
    }
});
